@if(initialized && privacyPolicy) {

<span class="info-page-text" [innerHTML]="privacyPolicy"></span>

}
